const ipfy = "at_sQEluxF2daTNMRGHr0VyZi3ucwyMh";

export default ipfy;
